<template>
   <table class="table table-hover" v-bind:style="[  'border: 1px solid #dcdede;' ]">
                <thead class="thead-third" v-if="columns">
                <slot name="header"></slot>
                <tr>
                    <th class="text-center thhead-cus">{{title}}</th>
                    <th class="text-center thhead-cus">{{dataSales.length}} Vendas</th>
                    <th class="text-center thhead-cus">{{formatMoney(totalSaleValue)}}</th>
                    <th class="text-center thhead-cus">{{rows.length}} Credenciadas</th>
                </tr>
                </thead>
                <thead class="thead-third" v-else>
                <slot name="thead"></slot>
                </thead>
                <tbody>
                <tr v-for="(row,i) in rows" :key="i">
                    <td class="text-center">{{row.nomeCredenciada}}</td>
                    <td class="text-center">{{row.quantidadeVendas}}</td>
                    <td class="text-center">{{formatMoney(row.valorTotal)}}</td>
                    <td></td>
                </tr>
                </tbody>
          </table>
</template>

<script>
import TableSalesReportsAccredited from './tablesalesreportsaccredited'
export default TableSalesReportsAccredited
</script>

<style scoped>
.thhead-cus{
    width: 20%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesbyaccredited/components/tablesalesreportsaccredited/tablesalesreportsaccredited.vue